import { apiSchematicMapBaseURL } from '../../authentication/Global';
import { apiFilesBaseURL  } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const generateApiRoutes = {
    draw: apiSchematicMapBaseURL + "draw/schematicmap/",
    list: apiSchematicMapBaseURL + "draw/schematicmap/list/",
    delete: apiFilesBaseURL + "files/delete/schematicmap/",
    deleteMultiple: apiFilesBaseURL + "files/delete/schematicmaps/",
};

export class DrawAPI {
    static generate(networkEdition, data) {
        const drawUrl = `${generateApiRoutes.draw}${networkEdition}`;

        return API.authenticatedRequest({
            url: drawUrl,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(data)
        });
    }

    static list(networkEdition) {
        const listUrl = `${generateApiRoutes.list}${networkEdition}`;
        return API.authenticatedRequest({
            url: listUrl,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

        static delete(fileName) {
            const url = `${generateApiRoutes.delete}${fileName}`;
    
            return API.authenticatedRequest({
                url: url,
                method: HTTPMethod.DELETE,
                contentType: ContentType.JSON,
                token: authenticationCentral.accessToken
            });
        }
    
        static deleteMultiple(filesName) {
            const url = generateApiRoutes.deleteMultiple;
    
            return API.authenticatedRequest({
                url: url,
                method: HTTPMethod.POST,
                contentType: ContentType.JSON,
                token: authenticationCentral.accessToken,
                body: JSON.stringify(filesName)
            });
        }
}
